<template>
  <div id="app">
    <router-view></router-view>
    <div class="backWrap">
      <div class="backBox">
        <div
          @click="$router.push('/home/userWelfare')"
          class="fareBox"
          v-if="$route.path === '/home/homePage'"
        >
          <!-- <img src="@/assets/app/app_1.png"> -->
          <span>
            <img src="@/assets/app/app_3.png">
          </span>
          <span>
            178元
            <br data-v-6a332d57>新人礼包
          </span>
        </div>
        <div class="kfBox" v-if="$route.path !== '/home/collectInfo'">
          <img src="@/assets/app/app_2.png" @click="showKfList = !showKfList" :class="{ active: showKfList }" />
          <div class="kfList" :class="{ show: showKfList }">
            <span @click="toKfFn('cn')">国内<br/>客服</span>
            <span @click="toKfFn()">海外<br/>客服</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      showKfList: false
    }
  },
  mounted() {},
  methods: {
    toKfFn(name) {
      if (name === "cn") {
        window.open(
          "https://ccc-v2.aliyun.com/v-chat?token=9XYGTGWtq2w10xZrv55J_XDk-X2inC6wl-EjVfzcRMmtr7NZ5h1GXkXpzhfXQA4nIIjIOmVkoV5C3GwwBVGH4Dd5jms0OFMgap4P7fAevuE%3D",
          "",
          "top=200,left=460,width=1000,height=660"
        )
      } else {
        window.open(
          "https://ccc-v2.aliyun.com/v-chat?token=9XYGTGWtq2w10xZrv55J_XDk-X2inC6wl-EjVfzcRMk0P4FQcBYb_e97lTyxcbQOxZMQev9qlncNn_o9QRt0E5LF54QOTLPFap4P7fAevuE%3D",
          "",
          "top=200,left=560,width=1000,height=660"
        )
      }
    }
  }
}
</script>
<style lang="less" scoped>
html,
body {
  font-size: 14px;
  height: 100%;
  margin: 0;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  p {
    margin: 0;
  }
}

#app {
  .backWrap {
    position: fixed;
    bottom: 30%;
    right: 0px;
    z-index: 999;

    .backBox {
      .fareBox {
        width: 80px;
        height: 40px;
        padding-left: 20px;
        border-radius: 20px 0 0 20px;
        background: #ffa705;
        display: flex;
        align-items: center;
        img {
          height: 20px;
          margin-right: 6px;
        }
        span {
          font-size: 12px;
          color: #fff;
        }
      }
      .kfBox {
        position: absolute;
        display: flex;
        top: 60px;
        right: 0;
        border-radius: 7px 0 0 7px;
        background-color: #fff;
        overflow: hidden;

        img {
          width: 28px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .kfList {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background: #fcc48f;
          overflow: hidden;
          width: 0;
          opacity: 0;
          transition: width 0.3s ease, opacity 0.3s ease;

          span {
            text-align: center;
            margin: 4px;
            padding: 4px;
            display: block;
            cursor: pointer;
            font-size: 12px;
            color: #fff;
            width: 46px;
            height: 40px;
            word-break: break-all;
            background: #f79646;
            border-radius: 5px;
            box-sizing: border-box;
          }
        }
        .kfList.show {
          width: 52px;
          opacity: 1;
        }
      }
    }
  }
}
</style>
